module.exports = __webpack_public_path__ + "img/ice-skate.54a6f863.svg";